import React from 'react';
import { Alert, Button, Card, Space, Tag } from 'antd';
import { useAuth } from '../contexts/AuthContext';

const resolveBlockedMessage = (accessState, blockingReason) => {
  const state = String(accessState || '').toLowerCase();
  const reason = String(blockingReason || '').toLowerCase();

  if (state === 'suspended') {
    if (reason.includes('grace_expirado') || reason.includes('trial_expirado')) {
      return {
        title: 'Assinatura suspensa por expiracao de prazo',
        description: 'O periodo de trial ou regularizacao foi encerrado. Regularize sua assinatura para voltar a acessar a plataforma.',
      };
    }
    return {
      title: 'Assinatura suspensa',
      description: 'Seu acesso esta suspenso no momento. Entre em contato com o administrativo para regularizacao.',
    };
  }

  if (state === 'cancelled') {
    return {
      title: 'Assinatura cancelada',
      description: 'A assinatura do tenant foi cancelada e o acesso esta indisponivel. Contate o suporte para reativacao.',
    };
  }

  if (state === 'no_subscription' || reason.includes('sem_assinatura')) {
    return {
      title: 'Tenant sem assinatura ativa',
      description: 'Nao encontramos uma assinatura SaaS ativa para este tenant. Fale com o administrativo para regularizar.',
    };
  }

  if (reason.includes('trial_expirado')) {
    return {
      title: 'Periodo trial encerrado',
      description: 'O trial foi encerrado. Regularize a assinatura para evitar indisponibilidade de acesso.',
    };
  }

  if (reason.includes('grace_expirado')) {
    return {
      title: 'Periodo de regularizacao encerrado',
      description: 'O prazo de grace terminou e o acesso foi bloqueado. Regularize a assinatura para voltar a operar.',
    };
  }

  return {
    title: 'Acesso temporariamente indisponivel',
    description: 'No momento nao foi possivel liberar o acesso a plataforma. Entre em contato com o administrativo ou com o suporte.',
  };
};

const TenantLifecycleBlocked = ({ accessState, blockingReason }) => {
  const { logout } = useAuth();
  const blockedMessage = resolveBlockedMessage(accessState, blockingReason);

  if (process.env.NODE_ENV !== 'production') {
    console.info('[TenantLifecycleBlocked] acesso indisponivel', {
      accessState,
      blockingReason,
    });
  }

  return (
    <div style={{ maxWidth: 760, margin: '40px auto', padding: '0 16px' }}>
      <Card title={blockedMessage.title}>
        <Alert
          type="info"
          showIcon
          message={blockedMessage.title}
          description={blockedMessage.description}
          style={{ marginBottom: 16 }}
        />

        <p>
          <Tag color="gold">Acesso indisponivel</Tag>
        </p>

        <Space>
          <Button type="primary" onClick={logout}>Sair</Button>
        </Space>
      </Card>
    </div>
  );
};

export default TenantLifecycleBlocked;
